<template>
    <div>
        <div
            class="row"
            v-if="single">
            <div class="col-md-12">
                <div
                    class="row"
                    v-for="item in itemsSingle"
                    style="margin-bottom: 5px">
                    <div class="col-md-2">
                        <b-button
                            variant="primary"
                            disabled
                            size="sm"
                            style="
                                font-size: 1.5em;
                                width: 100%;
                                text-align: left;
                                line-height: 100%;
                                background: rgb(56, 144, 207);
                                border-color: rgb(56, 144, 207);
                                opacity: 1;
                            ">
                            {{ item.name }}
                        </b-button>
                    </div>
                    <div class="col-md-10">
                        <b-form-textarea
                            v-model="item.value"
                            v-on:keydown="keyDown"
                            rows="1"
                            @blur="onSave"></b-form-textarea>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="row"
            v-if="!single">
            <div class="col-md-12">
                <div
                    class="row"
                    v-for="item in itemsDouble"
                    style="margin-bottom: 5px">
                    <div class="col-md-2">
                        <b-button
                            variant="primary"
                            disabled
                            size="sm"
                            style="
                                font-size: 1.5em;
                                width: 100%;
                                text-align: left;
                                line-height: 100%;
                                background: #0096d5;
                                opacity: 1;
                            ">
                            {{ item.name }}
                        </b-button>
                    </div>
                    <div class="col-md-5">
                        <b-form-textarea
                            v-model="item.value"
                            v-on:keydown="keyDown"
                            rows="1"
                            @blur="onSave"></b-form-textarea>
                    </div>
                    <div class="col-md-5">
                        <b-form-textarea
                            v-model="item.value_second"
                            v-on:keydown="keyDown"
                            rows="1"
                            @blur="onSave"></b-form-textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-lesson-show-slide-list-named-component',
    props: ['slideIn'],
    data() {
        return {
            slide: this.slideIn,
            itemsSingle: !this.slideIn.list_items.length
                ? [{ value: null, uses_double_columns: 0 }]
                : this.slideIn.list_items.filter((item) => item.uses_double_columns === 0),
            itemsDouble: !this.slideIn.list_items.length
                ? [{ value: null, uses_double_columns: 1 }]
                : this.slideIn.list_items.filter((item) => item.uses_double_columns === 1),
            single: true,
        };
    },
    watch: {
        slideIn(value) {
            this.slide = value;
            this.itemsSingle = !value.list_items.length
                ? [{ value: null, uses_double_columns: 0 }]
                : value.list_items.filter((item) => item.uses_double_columns === 0);
            this.itemsDouble = !value.list_items.length
                ? [{ value: null, uses_double_columns: 1 }]
                : value.list_items.filter((item) => item.uses_double_columns === 1);
        },
    },
    methods: {
        onSave() {
            let items = [...this.itemsSingle, ...this.itemsDouble];
            this.axios.post(this.routes.presentationSlideUpdateList(this.slide.id), { items: items }).then(
                (response) => {},
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        keyDown(event) {
            event.stopPropagation();
        },
        onClickSwitchSingleDouble() {
            this.single = !this.single;
        },
    },
};
</script>

<style>
#slides textarea {
    resize: vertical;
    overflow: hidden;
    border: 1px solid #000;
    font-size: 1.5em;
    height: 42px;
    padding: 5px;
    font-weight: bold;
    margin-bottom: 5px;
}
</style>
